import React, { useEffect } from "react";
import dronerepaire_image from "../../assets/image/png/EntrepreneurHeroImage.png";

const Entrepreneur = () => {
  useEffect(() => {
    const slider = document.querySelector(".timeline-slider");
    let isDown = false;
    let startX;
    let scrollLeft;

    slider.addEventListener("mousedown", (e) => {
      isDown = true;
      slider.classList.add("active");
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });

    slider.addEventListener("mouseleave", () => {
      isDown = false;
      slider.classList.remove("active");
    });

    slider.addEventListener("mouseup", () => {
      isDown = false;
      slider.classList.remove("active");
    });

    slider.addEventListener("mousemove", (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 3; // Scroll-fast
      slider.scrollLeft = scrollLeft - walk;
    });
  }, []);

  return (
    <div className="py-5 bg-white">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6 mt-4">
            <h3 className="fs_34 ff_raleway fw-bold mb-2">
              Join Our Drone Entrepreneurship Program
            </h3>
            <p className="fs_16 ff_helvetica fw-normal mb-4">
              Join our program to learn drone piloting, start your business, and thrive in a high-demand industry. Begin your exciting journey in the drone industry with our expert-led program. Gain the skills, knowledge, and support to turn your passion into a profitable business.
            </p>

            <h3 className="fs_34 ff_raleway fw-bold mb-2">About the Program</h3>
            <p className="fs_16 ff_helvetica fw-normal mb-4">
              Transform your future with our comprehensive drone entrepreneurship program. Learn, earn, and grow in the booming drone industry.
            </p>

            <h3 className="fs_34 ff_raleway fw-bold mb-2">Key Features</h3>
            <ul className="list-unstyled mt-2">
              <li className="color_darkgray_3 mb-2">
                <p className="fs_16 ff_helvetica fw_400 mb-0">
                  Drone Pilot Training: Master drone flying with hands-on training.
                </p>
              </li>
              <li className="color_darkgray_3 mb-2">
                <p className="fs_16 ff_helvetica fw_400 mb-0">
                  Business Setup: Launch and grow your own drone services.
                </p>
              </li>
              <li className="color_darkgray_3 mb-2">
                <p className="fs_16 ff_helvetica fw_400 mb-0">
                  Expert Support: Get continuous mentorship and network with industry leaders.
                </p>
              </li>
            </ul>
          </div>
          <div className="col-lg-6 mt-5 mt-lg-0">
            <img
              className="w-100"
              src={dronerepaire_image}
              alt="Entrepreneur Hero"
              style={{ borderRadius: "10px", boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)" }}
            />
          </div>
        </div>

        {/* Timeline */}
        <h3 className="fs_34 ff_raleway fw-bold mb-0 mt-4 py-5 bg-white">
          Journey of a Drone Entrepreneur
        </h3>
        <div className="timeline-slider bg-white" >
          {[
            { step: "Step 1", title: "Join Drone Pilot Training", description: "Become a certified drone pilot with our expert training." },
            { step: "Step 2", title: "Start Your Own Drone Business", description: "Purchase a drone and offer services like spraying and seeding." },
            { step: "Step 3", title: "Expand as a Drone Distributor", description: "Grow your business by distributing drones and accessories." },
            { step: "Step 4", title: "Provide RPTO Assistance", description: "Help others set up Remote Pilot Training Organizations." },
            { step: "Step 5", title: "Power Platform Details", description: "Scale your business with comprehensive drone solutions." }
          ].map((item, index) => (
            <div key={index} className="timeline-item">
              <div className="timeline-step">
                <span className="step-count">{item.step.slice(-1)}</span> {/* Get last character of the step for number */}
                <span>{item.title}</span>
              </div>
              <p>{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Entrepreneur;
